export default "/assets/images/big-sneeze5.png?7f0608d73871f5acbb091550c7a752d5";